import EditProduct from "@/apsales/Products/Edit";

export default function AddProduct() {
    return <EditProduct mode="add"/>;
}